// based on rc-cascader 0.17.4
import Cascader from './Cascader';
export default Cascader;